import { useMemo } from 'react';

import {
  FlashMessageCloseButton,
  FlashMessageCloseButtonHolder,
  FlashMessageContainer,
  FlashMessageHeadline,
} from 'components/FlashMessage/FlashMessage.styled';
import { useI18n } from 'i18n/hooks/useI18n';

import { flashMessageTypeMapFn } from './flashMessageTypeMap';

type Props = {
  flashMessage: FlashMessageType;
  removeMessage: () => void;
};

export function FlashMessage({ flashMessage, removeMessage }: Props) {
  const { i18n } = useI18n();

  const flashMessageTypeMap = useMemo(
    () => flashMessageTypeMapFn(i18n),
    [i18n],
  );

  const { message, style } = flashMessageTypeMap[flashMessage.type](
    flashMessage.data,
  );

  const closeHandler = () => {
    removeMessage();
    flashMessage.onRemove?.();
  };

  return (
    <FlashMessageContainer data-qa-id="flash-message" $variant={style}>
      <FlashMessageHeadline>{message}</FlashMessageHeadline>
      <FlashMessageCloseButtonHolder>
        <FlashMessageCloseButton
          type="button"
          qaId="flash-message-close"
          onClick={closeHandler}
          aria-label={i18n('Close alert message')}
          icon={{ type: 'normalized', name: 'close' }}
          variant={style === 'warn' ? 'tertiary-grey' : 'tertiary-white'}
        />
      </FlashMessageCloseButtonHolder>
    </FlashMessageContainer>
  );
}
